import authTokenUtil from '../../account/authTokenUtil';
import Logger from '../Logger';

function respond(response: Response) {
  return new Promise((resolve, reject) => {
    const handleUnknownError = (message: string) => {
      response.text().then((responseText: string) => {
        Logger.error(`${message} when requesting ${response.url}`, {
          response: responseText,
          source: 'utils/network/request.js',
        });
      });
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      reject();
    };

    if (response.status >= 200 && response.status < 300) {
      response
        .json() // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((json: any) => {
          if (!json.errors) {
            resolve(json.data);
          } else {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            reject(json.errors);
          }
        })
        .catch(() => handleUnknownError('JSON parsing error'));

      return;
    }

    handleUnknownError('Unknown error');
  });
}

export default function request<
  Data extends Record<string, string | string[] | undefined | null>,
>(url: string, method: string, data?: Data) {
  let fetchUrl = url;
  let fetchData: Data | undefined | null = data;

  if (data && method === 'GET') {
    const searchParams = new URLSearchParams();

    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          searchParams.append(`${key}[]`, v);
        });
      } else if (value !== undefined) {
        searchParams.set(key, value ?? '');
      }
    });

    const queryString = searchParams.toString();
    fetchUrl = queryString ? `${url}?${queryString}` : url;
    fetchData = null;
  }

  const authToken = authTokenUtil.get();
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const authHeader: any = authToken ? { Authorization: authToken } : {};
  return fetch(fetchUrl, {
    body: fetchData && JSON.stringify(fetchData),
    headers: {
      ...authHeader,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method,
  }).then(respond);
}
